module.exports = __webpack_public_path__ + "static/img/product1.9a25e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yellow/product1.png
// module id = p7OO
// module chunks = 0